<div class="bg-[#05143F] h-[68px] relative px-10 flex justify-between items-center">
  <!-- Left Side (Logo) -->
  <img class="w-32 h-10" src="/images/logommcg.svg" alt="" />

  <!-- Right Side (Role + Profile) -->
  <div class="gap-2 flex items-center relative">
    <!-- Small Badge -->
    @if(!trainingCompleted && !isNoTrainingAssigned){
    <span (click)="moveToTraining()"
      class="absolute cursor-pointer hover:bg-white hover:text-red-800 -top-3 -right-8 border bg-red-800 text-white text-[8px] font-bold px-2 py-0.5 rounded-md shadow-md">
      Training Incomplete
    </span>
    }

    <div [matMenuTriggerFor]="menu" class="flex gap-2 items-center cursor-pointer hover:scale-105">
      <img matButton class="w-10 h-10 border border-white cursor-pointer rounded-full"
        [src]="(userInfo.profileImage && userInfo.profileImage.length > 0) ? userInfo.profileImage : profileIcon"
        alt="" />
      <div>
        <p class="text-white font-bold">{{name}}</p>
        <p class="text-white text-xs">{{ roleName }}</p>
      </div>

    </div>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="logout()">Logout</button>
    </mat-menu>
  </div>
</div>